import { render, staticRenderFns } from "./ElementZoom.vue?vue&type=template&id=cbbb0eb6&scoped=true&"
import script from "./ElementZoom.vue?vue&type=script&lang=js&"
export * from "./ElementZoom.vue?vue&type=script&lang=js&"
import style0 from "./ElementZoom.vue?vue&type=style&index=0&id=cbbb0eb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbbb0eb6",
  null
  
)

export default component.exports